import { useTestContext } from "./TestContext";
import { getTestAttributeGenerators } from "./utils";

export const useTestAttributes = () => {
    const prefix = useTestContext();

    return getTestAttributeGenerators(prefix);
};
